import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import UserContext from '../../context/user/userContext';

const UserItem = ({ user }) => {
  const userContext = useContext(UserContext);
  const { deleteUser, setCurrent, clearCurrent } = userContext;

  const { id, name, email, role } = user;

  const onDelete = () => {
    deleteUser(id);
    clearCurrent();
  };

  return (
    <div className='card bg-light'>
      <h3 className='text-primart text-left'>
        {name}{' '}
        <span
          style={{ float: 'right', width: '100px' }}
          className={
            'badge ' +
            (role === 'admin'
              ? 'badge-success'
              : role === 'user'
              ? 'badge-primary'
              : 'badge-gold')
          }
        >
          {role.charAt(0).toUpperCase() + role.slice(1)}
        </span>
      </h3>
      <ul className='list mt-3'>
        {email && (
          <li>
            <i className='fas fa-envelope-open'></i> {email}
          </li>
        )}
      </ul>
      <p>
        <button
          className='btn btn-dark btn-sm'
          onClick={() => setCurrent(user)}
        >
          Edit
        </button>
        <button className='btn btn-danger btn-sm' onClick={onDelete}>
          Delete
        </button>
      </p>
    </div>
  );
};

UserItem.propTypes = {
  user: PropTypes.object.isRequired
};

export default UserItem;
